<template>
  <div>
    <div
      class="justify-center mt-4 sm:mt-10 hidden sm:flex"
    >
      <button
        type="button"
        class="px-0 font-bold text-[#171717] social-btn bg-b95 al-btn sm:px-48 lg:px-52"
        @click="proxyRedirect('google')"
      >
        <SvgIcon class="-mt-[2px]" icon="google-al" />
        Google
      </button>
    </div>
    <div
      v-if="!isShowMobileForm"
      class="flex flex-col sm:hidden justify-center mt-6 sm:mt-10 px-5"
    >
      <div class="text-sm text-center text-b50 mb-4">
        No credit card required
      </div>
      <button
        type="button"
        class="mx-0 font-bold text-[#171717] social-btn social-btn-mobile bg-b95 al-btn sm:mr-4 sm:px-8 w-full flex justify-between px-6 mb-5"
        @click="proxyRedirect('google')"
      >
        <SvgIcon icon="google-al" />
        <span class="w-full text-center">Continue with Google</span>
      </button>
      <div class="relative z-10 mt-5 text-sm text-center or sm:mt-8">
        <span class="px-4 bg-white">or</span>
      </div>
      <button
        type="button"
        class="mx-0 my-4 font-bold border border-ma-black-0 text-ma-black-0 al-btn sm:mr-4 sm:px-8 w-full flex justify-between px-6"
        @click="continueWithEmail"
      >
        <i
          data-v-fb69bce4=""
          class="mr-2 fa fa-envelope fa-fw text-xl"
        />
        <span class="w-full text-center">Continue with Email</span>
      </button>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    proxyRedirect: {
      type: Function,
      default: (() => {}),
      required: true,
    },
    isShowMobileForm: {
      type: Boolean,
      default: true,
    },
    continueWithEmail: {
      type: Function,
      default: (() => {}),
      required: true,
    },
  },
};
</script>

<style scoped>
.-mt-\[2px\] {
  margin-top: -2px;
}
.text-\[\#171717\] {
  color: #171717;
}
.social-btn {
  width: 155px;
  transition: 0.3s all;
}
.social-btn-mobile {
  width: 100%;
}
.social-btn:hover {
  opacity: 0.9;
}
.or {
  color: #828282;
}
.or:before {
    content: '';
    width: 100%;
    display: block;
    height: 1px;
    background-color: #efefef;
    position: absolute;
    top: 50%;
    z-index: -1;
}
@screen sm {
  .social-btn {
    width: 180px;
  }
}
</style>
